module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAACbSURBVHgBtZbbCcAgEASvBEu0c0tICRtFEUnwce7dQn6UnUlUMCItAIIY5cfKAwk1UcgURn6ewuy2NgBW0uBjwmwiijJbBiM57t5I1B1N4fqrT4pg920FoOErkBl8IbGDbyRRrOIqcF0i102G5zE9AVxLNEW15Oatjjsg1nXbBfiTMWWgXpkUfCIp13C/MlMbiEJmkKTvhMtvywsxgPf/RmBemAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/watch-video-arrow.png
// module id = 13
// module chunks = 0